export default __webpack_public_path__ + "static/media/warning--trucks-crossing--g2.8ba4f009.png";